import React, { Component } from 'react';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Button from "components/CustomButtons/Button.jsx";

// Where the public author profile is edited now (the new CMS profile page).
const NEW_CMS_PROFILE_URL = 'https://cms.pubninja.com/profile';

const styles = {
  pageTitle: {
    fontSize: '20px',
    fontWeight: 600,
    color: '#2b2d42',
    marginBottom: '4px',
  },
  pageSubtitle: {
    fontSize: '13px',
    color: '#8d99ae',
    marginBottom: '20px',
  },
  lead: {
    fontSize: '14px',
    color: '#2b2d42',
    lineHeight: '1.6',
    margin: '8px 0 4px',
  },
  hint: {
    fontSize: '12px',
    color: '#8d99ae',
    lineHeight: '1.5',
    marginTop: '10px',
  },
  fieldList: {
    fontSize: '13px',
    color: '#5d737e',
    margin: '14px 0 4px',
    paddingLeft: '18px',
    lineHeight: '1.8',
  },
};

/**
 * Author Profile (old CMS) — a front door into the new CMS.
 *
 * The public author profile is edited in the new CMS. This screen opens the new
 * CMS profile page in a new tab. If the user isn't signed in there, the new CMS
 * shows its own login screen and returns them to their profile after login
 * (post-login redirect is handled by the new CMS).
 */
class AuthorProfileForm extends Component {
  onOpenNewEditor = () => {
    // Navigate this tab to the new CMS profile (not a new tab). If the user isn't
    // signed in there, the new CMS shows its login and returns them to /profile.
    window.location.assign(NEW_CMS_PROFILE_URL);
  }

  render() {
    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={10} md={8} lg={6}>
          <div style={{ marginTop: '20px' }}>
            <div style={styles.pageTitle}>Author Profile</div>
            <div style={styles.pageSubtitle}>
              Your public author profile is now managed in the new CMS.
            </div>
          </div>

          <Card>
            <CardBody>
              <p style={styles.lead}>
                Edit your public author profile — the details shown on your author page — in the new CMS.
              </p>
              <ul style={styles.fieldList}>
                <li>First &amp; last name, Headline, About</li>
                <li>Profile picture</li>
                <li>LinkedIn &amp; X (Twitter)</li>
              </ul>
              <p style={styles.hint}>
                Takes you to your profile in the new CMS. If you&rsquo;re not signed in there, log in and
                you&rsquo;ll land right on your profile.
              </p>
            </CardBody>
            <CardFooter style={{ justifyContent: 'center', paddingBottom: '20px' }}>
              <Button
                color="info"
                size="lg"
                onClick={this.onOpenNewEditor}
              >
                Open profile editor in the new CMS
              </Button>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

export default AuthorProfileForm;
